import moment from 'moment-timezone';

const numberWithCommas = (x) => {
  var parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export function format (value, placeholder, type) {
  if (value !== null && value !== undefined) {
    switch (type) {
      case 'int':
        if (typeof value === 'string') value = parseFloat(value);
        value = numberWithCommas(value.toFixed(0));
        break;

      case 'seconds':
        if (typeof value === 'string') value = parseFloat(value);
        if (value < 1) value = '< 1s';
        if (value >= 1) value = `${numberWithCommas(value.toFixed(0))}s`;
        break;

      case 'float':
        if (typeof value === 'string') value = parseFloat(value);
        if (isNaN(value)) return placeholder;
        value = numberWithCommas(value.toFixed(2));
        break;

      case 'price':
        value = parseFloat(value);
        if (isNaN(value)) return placeholder;
        value = numberWithCommas(value.toFixed(6).replace(/0{0,4}$/, ''));
        break;

      case 'millions':
        value = parseFloat(value);
        if (isNaN(value)) return placeholder;
        value = value / 1000000.0;
        value = numberWithCommas(value.toFixed(2));
        break;

      case 'percentage':
        value = parseFloat(value);
        if (isNaN(value)) return placeholder;
        value = numberWithCommas(value.toFixed(2));
        if (value === '-0.00') value = '0.00';
        if (value.length > 0) value += '%';
        break;

      case 'tenths':
        value = parseFloat(value);
        if (isNaN(value)) return placeholder;
        value = numberWithCommas(value.toFixed(1));
        if (value === '-0.00') value = '0.00';
        if (value.length > 0) value += '%';
        break;

      case 'sign':
        const sign = parseFloat(value) > 0 ? '+' : '';
        value = numberWithCommas(value.toFixed(2));
        if (value.length > 0) value = sign + value;
        break;

      case 'bool':
        value = value ? 'Yes' : 'No';
        break;

      case 'date':
        value = moment(value).tz('America/New_York').format('MM/DD/YYYY');
        break;

      case 'staticDate':
        value = moment(value).format('MM/DD/YYYY');
        break;

      case 'isoDate':
        value = moment(value).format('YYYY-MM-DD');
        break;

      case 'time':
        value = moment(value).format('HH:mm:ss.SSS');
        break;

      case 'dateTime':
        value = moment(value).format('MM/DD/YYYY HH:mm:ss.SSS');
        break;

      case 'text':
        break;

      default:
        break;
    }
  } else {
    value = placeholder;
  }

  return value;
}
